import debounce from 'lodash/debounce'
import sniffer from 'sniffer'
import config from 'src/config'

class Values {
  constructor() {
    this.init()
    this.onResize()
    this.updateScrollingState = debounce(this.updateScrollingState, 400)

    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
  }

  init() {
    sniffer.addClasses(document.documentElement)
    this.sniffer = sniffer.getInfos()

    const ratio = window.devicePixelRatio
    this.ratio = ratio <= 2 ? ratio : 2

    this.breakpoints = {
      xs: 480,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1440
    }

    this.viewport = {
      width: 0,
      height: 0
    }

    this.mouse = {
      x: 0,
      y: 0
    }

    this.touch = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      deltaX: 0,
      deltaY: 0
    }

    this.scroll = {
      currentY: 0,
      targetY: 0,
      height: 0,
      delta: 0,
      directionY: 0,
      directionX: 0
    }

    this.scrollY = document.documentElement.scrollTop || document.body.scrollTop
    this.oldScrollY = this.scrollY
    this.scrollDirection = 0

    this.drag = {
      currentY: 0,
      targetY: 0,
      delta: 0
    }
  }

  onScroll = () => {
    this.isScrolling = true

    this.scrollDirection = this.oldScrollY - this.scrollY > 0 ? -1 : 1
    this.oldScrollY = this.scrollY

    this.scrollY = document.documentElement.scrollTop || document.body.scrollTop

    this.updateScrollingState()
  }

  updateScrollingState = () => {
    this.isScrolling = false
  }

  onResize = () => {
    this.viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    this.isMobile = this.viewport.width < config.bp.md
  }
}
const values = new Values()
export default values



// WEBPACK FOOTER //
// ./src/values.js